import * as S from './style'
import LayoutDetails from '../../../../components/LayoutModal/LayoutDetails';
import axiosInstance from 'services/axiosInstance';
import { useEffect, useState } from 'react';
import Loading from '../../../../components/Loading';
import useLoading from "../../../../hooks/useLoading";
//Interface
import { IExpense } from 'Interfaces/IExpense';
// utils
import FormatarData from 'utils/FormatData';

interface IDetails {
    isOpenModal: boolean;
    setModalClose: () => void;
    selectedUrlId: number | null;
}

export default function Details({ isOpenModal, setModalClose, selectedUrlId }: IDetails) {
    const [data, setData] = useState<IExpense | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`expense/${selectedUrlId}`);
            setData(response.data);
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        if (isOpenModal && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModal, selectedUrlId])

    if (isOpenModal) {
        return (
            <LayoutDetails
                title='Detalhes da Saída'
                subTitle='Veja todos os detalhes disponíveis sobre a saída.'
                setModalClose={setModalClose}>
                {isLoading || !data ? ( 
                    <Loading />
                ) : (
                    <S.Content>
                        <S.Header>
                            <S.ContentInfor>
                                <S.Infor>
                                    <p>Nome da Saída:</p>
                                    <span>{data.title || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Categoria:</p>
                                    <span>{data.category_expenses?.category_expense || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Valor:</p>
                                    <span>{data.total_amount || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Data:</p>
                                    <span>{FormatarData(data.date_proof, 'default') || '-'}</span>
                                </S.Infor>
                            </S.ContentInfor>
                        </S.Header>

                        <S.Body>
                            <S.FeaturedSection>
                                <S.InforBody>
                                    <p>Anexo</p>
                                    <S.Description>{data.proofs || '-'}</S.Description>
                                </S.InforBody>
                            </S.FeaturedSection>

                            <S.InforBody>
                                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                            </S.InforBody>
                        </S.Body>
                    </S.Content>
                )}
            </LayoutDetails>
        )
    } return null
}